import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import config from 'config';

import {canonicalLink} from 'utils/seoUtils';
import {toSlug} from 'utils';
import {categoryAdvertView, categoryUrlRoot, getArticleId} from 'utils/ArticleUtils';

import {getMetaDataWidgetValue} from 'modules/News/utils';
import {getBodyWidgets, getWidgetValue, getPrimaryMediaWidgetId} from "sportinglife-react-common/widgets";

import AdvertWrapper from "modules/Common/components/AdvertWrapper";
import GptAdvert from 'modules/Common/components/GptAdvert';
import ArticleSocialMediaButtons from 'modules/News/components/ArticleSocialMediaButtons';
import EnhancedLoginPrompt, {EnhancedLoginPromptHeading} from 'modules/Common/components/EnhancedLoginPrompt';
import {getSection} from 'utils/commonUtils';
import {withRouter} from 'react-router';
import ArticleSubheading from "./ArticleSubheading";
import ArticleAuthor from "./ArticleAuthor";
import {singleBottomMPUProps} from "../../Common/components/GptProperties";
import {get} from 'lodash';
import ArticleHelmetProps from "./ArticleHelmetProps";
import getWidget from "./widgets/getWidget";
import ArticleHeroImage from "./ArticleHeroImage";
import {withErrorBoundary} from "../../Errors/components/withErrorBoundry";

require('./Article.scss');

export class PureArticle extends Component {
  static propTypes = {
    loggedIn: PropTypes.bool,
    races: PropTypes.array,
    routes: PropTypes.array,
    media: PropTypes.object.isRequired,
    articleId: PropTypes.number,
    articleIdRef: PropTypes.string,
    embedded: PropTypes.bool,
    embeddedLabel: PropTypes.string,
    params: PropTypes.shape({
      matchId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      articleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    }),
    article: PropTypes.object,
    actualArticleId: PropTypes.string
  };

  shouldComponentUpdate(nextProps) {
    const isUserLeavingArticle = nextProps.actualArticleId === undefined;
    return !isUserLeavingArticle;
  }

  articleSuccess(article, widgets) {
    const { embedded, routes, loggedIn } = this.props;
    const primaryImageId = getPrimaryMediaWidgetId(widgets);
    const topImageSet = this.props.media[primaryImageId] || [];

    const articleBodyWidgets = getBodyWidgets(widgets);

    const shareProps = {};

    const firstTextArea = articleBodyWidgets.find((bodyWidget) => bodyWidget.widget_type === "TextArea");
    const textContent = getWidgetValue(firstTextArea, "html")
    shareProps.firstParagraph = textContent.trim();

    let canonical = undefined;

    if (!embedded) {
      if (routes && routes.length) {
        let routeArray = [...routes].filter(r => !!r.path);

        if (routeArray.length === 2) { // the generic "news" route
          routeArray = [routeArray[0], null, routeArray[1]]; // make a space
        }

        routeArray[1] = {path: categoryUrlRoot(article.category)};
        canonical = canonicalLink(routeArray, {articleId: this.props.actualArticleId, title: toSlug(article.title)});
        shareProps.page = canonical.link[0].href;
        shareProps.title = article.title;
      }
    }

    const editorVersion = getMetaDataWidgetValue(article.widgets, "editorVersion") || "legacy";
    const contentClassName = `news-article-body-${editorVersion}`;

    const bodyVisible = !article.login_required || loggedIn;

    const section = getSection(routes);
    const view = categoryAdvertView(article.category);

    return (
      <div className="news-article">
        <ArticleHelmetProps
          embedded={embedded}
          article={article}
          canonical={canonical}
          topImageSet={topImageSet}
        />
        <div className="news-article-heading">
          {!embedded && article.long_headline &&
          <h1 className="article-title">{article.long_headline}</h1>
          }
          {!embedded && <ArticleSubheading article={article} />}
        </div>
        <ArticleHeroImage
          articleId={this.props.actualArticleId}
          widgets={widgets}
        />
        <div className={contentClassName}>
          {topImageSet.caption && topImageSet.caption.trim() &&
          <div className="photo-caption">{topImageSet.caption}</div>
          }
          {!article.sensitive &&
          <AdvertWrapper
            ocSlot={[view, "leaderboard"]}
            additionalProperties={{view: view}}
          />
          }
          <ArticleAuthor article={article} />
          {article.article_abstract &&
          <p className="article-intro">{article.article_abstract}</p>
          }
          <div className={!bodyVisible && "news-article-login-required" || undefined}>
            {articleBodyWidgets.map((widget, i) => {
              const {Widget, widgetProps} = getWidget({
                widget: widget,
                view: view,
                bodyVisible: bodyVisible,
                article: article,
                media: this.props.media
              })

              return (
                <Widget
                  key={i}
                  {...widgetProps}
                />)
            })}
            {!bodyVisible && <div className="news-article-login-prompt">
              <h2>{EnhancedLoginPromptHeading}</h2>
              <EnhancedLoginPrompt size="standard"/>
            </div>}
          </div>
          {!article.sensitive && <ArticleSocialMediaButtons {...shareProps} />  }
          {!article.sensitive &&
          <GptAdvert
            ocDetails={{
              hash: config.oddschecker.slotID.homepage.leaderboard
            }}
            performDetails={{
              ...singleBottomMPUProps,
              ...section}}
          />
          }
        </div>
      </div>
    );
  }

  articleFailed() {
    const errorPixelSrc = `/1x1.gif?type=article&id=${this.props.actualArticleId}&cb=${Date.now()}`;
    return (
      <div>
        <div className="default-no-article">This article could not be displayed.</div>
        <img src={errorPixelSrc} width="1" height="1"/>
      </div>
    );
  }

  articleFailedEmbed(label) {
    return (
      <div className="default-no-article">
        There is currently no {label.toLowerCase()}.
      </div>
    );
  }

  render() {
    const article = this.props.article;

    if (!article) {
      const label = this.props.embeddedLabel;
      return label ? this.articleFailedEmbed(label) : this.articleFailed();
    }

    const widgets = article.widgets || [];

    return this.articleSuccess(article, widgets);
  }
}

const mapStateToProps = (state, ownProps) => {
  const loggedIn = get(state, 'common.auth.loggedIn', false);
  const { article: articles, media } = state.common;
  const actualArticleId = getArticleId(ownProps);

  const article = get(articles, `${actualArticleId}.article`, undefined);

  return {
    article,
    actualArticleId,
    media,
    loggedIn
  };
}

export default withErrorBoundary(withRouter(connect(mapStateToProps)(PureArticle)));



// WEBPACK FOOTER //
// ./modules/News/components/Article.js